import { analyticsFinanceApi } from '../features/AnalyticFinance/service/finance.api';
import { analyticsMessagesApi } from '../features/AnalyticMessages/service/messages.api';
import { analyticsModerationApi } from '../features/AnalyticModeration/service/moderation.api';
import { analyticsMembersApi } from '../features/AnalyticMembers/service/members.api';
import { analyticsRecommendationApi } from '../features/Recommendation/service/recommendation.api';
import { analyticFiltersReducer } from './analyticFiltersSlice';
import { analyticSelectorReducer } from './analyticSelectorSlice';
import { analyticsPostsApi } from '../features/AnalyticPosts/service/posts.api';

export const analyticsApi = [
    analyticsFinanceApi.middleware,
    analyticsMessagesApi.middleware,
    analyticsModerationApi.middleware,
    analyticsMembersApi.middleware,
    analyticsPostsApi.middleware,
    analyticsRecommendationApi.middleware,
];

export const analyticsReducers = {
    [analyticsFinanceApi.reducerPath]: analyticsFinanceApi.reducer,
    [analyticsMessagesApi.reducerPath]: analyticsMessagesApi.reducer,
    [analyticsModerationApi.reducerPath]: analyticsModerationApi.reducer,
    [analyticsMembersApi.reducerPath]: analyticsMembersApi.reducer,
    [analyticsPostsApi.reducerPath]: analyticsPostsApi.reducer,
    [analyticsRecommendationApi.reducerPath]:
        analyticsRecommendationApi.reducer,
    analyticFilters: analyticFiltersReducer,
    analyticSelector: analyticSelectorReducer,
};
